import { render, staticRenderFns } from "./TopicoDialog.vue?vue&type=template&id=58037988&"
import script from "./TopicoDialog.vue?vue&type=script&lang=js&"
export * from "./TopicoDialog.vue?vue&type=script&lang=js&"
import style0 from "./TopicoDialog.vue?vue&type=style&index=0&id=58037988&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports